var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLiaisonAccess = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55556 0.972656H2.77778C2.30628 0.972656 1.8541 1.15996 1.5207 1.49336C1.1873 1.82675 1 2.27894 1 2.75043V4.52821",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4453 0.972656H15.2231C15.6946 0.972656 16.1468 1.15996 16.4802 1.49336C16.8136 1.82675 17.0009 2.27894 17.0009 2.75043V4.52821",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55556 16.9735H2.77778C2.30628 16.9735 1.8541 16.7862 1.5207 16.4528C1.1873 16.1194 1 15.6672 1 15.1957V13.418",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4453 16.9735H15.2231C15.6946 16.9735 16.1468 16.7862 16.4802 16.4528C16.8136 16.1194 17.0009 15.6672 17.0009 15.1957V13.418",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00087 4.52734C7.79198 4.52734 6.86753 5.49031 6.86753 6.74957V7.49031C6.08531 7.49031 5.44531 8.15697 5.44531 8.97179V11.9348C5.44531 12.7496 6.08531 13.4162 6.86753 13.4162H11.1342C11.9164 13.4162 12.5564 12.7496 12.5564 11.9348V8.97179C12.5564 8.15697 11.9164 7.49031 11.1342 7.49031V6.74957C11.1342 5.49031 10.2098 4.52734 9.00087 4.52734ZM9.71198 7.49031H8.28976V6.74957C8.28976 6.30512 8.5742 6.00883 9.00087 6.00883C9.42753 6.00883 9.71198 6.30512 9.71198 6.74957V7.49031Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLiaisonAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/liaisonAccess.d9991494e0406ab6cdd6f5fbe3d8a063.svg";